module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szerzigeny1.e877f7d1.jpg";